import React from 'react';

interface ProductVisualProps {
  type: 'nova' | 'geo' | 'croplens' | 'drought';
  image: string;
}

const typeLabels: Record<string, string> = {
  nova: 'NOVA',
  geo: 'GEO',
  croplens: 'CROPLENS',
  drought: 'DROUGHT WATCH',
};

export const ProductVisual: React.FC<ProductVisualProps> = ({ type, image }) => {
  return (
    <div className="w-full aspect-square rounded-lg bg-slate-50 dark:bg-slate-900/40 overflow-hidden border border-slate-100 dark:border-white/[0.04] relative flex items-center justify-center select-none">
      <img 
        src={image} 
        alt={type} 
        loading="lazy"
        className="w-full h-full object-cover select-none pointer-events-none brightness-[0.75] transition-all duration-500 group-hover:scale-102"
        draggable={false}
        onContextMenu={(e) => e.preventDefault()}
      />
      {/* Dark overlay for contrast */}
      <div className="absolute inset-0 bg-black/15 group-hover:bg-black/25 transition-colors duration-300" />
      
      {/* Brand Signature Bar at Top-Left */}
      <div className="absolute top-4 left-4 w-1 h-6 bg-gradient-to-b from-cyan-400 to-[#0E93A3] rounded-sm shadow-[0_0_8px_rgba(14,147,163,0.6)] z-20" />

      {/* Capitalized Name Overlay */}
      <div className="absolute inset-0 flex items-center justify-center p-4">
        <span 
          className="text-white text-3xl md:text-[2rem] font-black tracking-[0.2em] text-center select-none drop-shadow-[0_4px_16px_rgba(0,0,0,0.95)] transition-all duration-500 group-hover:scale-105"
          style={{ fontFamily: "'IBM Plex Sans Condensed', 'Inter', sans-serif" }}
        >
          {typeLabels[type]}
        </span>
      </div>
    </div>
  );
};
